import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../components/Home";
import News from "@/components/News";
import Arhiva from "@/components/Arhiva";
import Blog from "@/components/Blog";
import BlogDetails from "@/components/BlogDetails";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/novosti/:alias',
        name: 'News',
        component: News
    },
    {
        path: '/arhiva/:alias',
        name: 'Arhiva',
        component: Arhiva
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog
    },
    {
        path: '/blog/:alias',
        name: 'BlogDetails',
        component: BlogDetails
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            // Pričekaj da se naslovnica iscrta prije skoka na sekciju
            return new Promise(resolve => {
                setTimeout(() => resolve({selector: to.hash, offset: {x: 0, y: 84}}), 450)
            })
        }
        if (savedPosition) return savedPosition
        return {x: 0, y: 0}
    }
})

export default router
